import { render, staticRenderFns } from "./studentExaminationRoomQueryList.vue?vue&type=template&id=f51394ea&scoped=true"
import script from "./studentExaminationRoomQueryList.vue?vue&type=script&lang=js"
export * from "./studentExaminationRoomQueryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51394ea",
  null
  
)

export default component.exports